<template>
    <!-- TODO: REMOVE if when ok -->
    <landing v-if="userData && userData.is_staff">
        <v-container>
            <v-row>
                <v-col>
                    <div
                        :class="{
                            'display-3': $vuetify.breakpoint.mdAndUp,
                            'display-2': $vuetify.breakpoint.smAndDown,
                        }"
                        class="font-weight-bold"
                    >
                        {{title}}
                    </div>

                    <slot name="options"></slot>
                    <!-- <div class="mt-5 headline">Selecciona un plan</div> -->
                    <v-form v-model="valid" style="width: 100%" @submit.prevent="submit_func">
                        <v-radio-group v-model="service_plan" :rules="requiredRule">
                            <v-container>
                                <v-row>
                                    <v-col offset-md="1" md="10">
                                        <v-card
                                            :elevation="
                                                service_plan && service_plan == plan.id
                                                ? 10
                                                : 2
                                            "
                                            color="transparent"
                                            class="plans d-flex justify-space-around mb-5"
                                            v-for="plan in contract_types"
                                            :key="plan.id"
                                            @click="!!(!(disabled && contract.contract_type && contract.contract_type.order >= plan.order)) && selectPlan(plan.id)"
                                        >
                                            
                                            <div 
                                                class="flex-grow-1 d-flex align-center"
                                                :class="{
                                                    disabled: disabled && contract.contract_type && contract.contract_type.order >= plan.order,
                                                }"
                                            >
                                                <v-radio :disabled="disabled && contract.contract_type && contract.contract_type.order >= plan.order" :value="plan.id"></v-radio>
                                            </div>
                                            <div 
                                                class="flex-grow-1 d-flex align-center"
                                                :class="{
                                                    disabled: disabled && contract.contract_type && contract.contract_type.order >= plan.order,
                                                }"
                                            >
                                                <span>
                                                    Hasta {{ plan.docs_num.toLocaleString() }} docs/año
                                                </span>
                                            </div>
                                            <div 
                                                class="flex-grow-1 d-flex align-center"
                                                :class="{
                                                    disabled: disabled && contract.contract_type && contract.contract_type.order >= plan.order,
                                                }"
                                            >
                                                <span>Usuarios ilimitados</span>
                                            </div>
                                            <div 
                                                class="flex-grow-1 d-flex align-center"
                                                :class="{
                                                    disabled: disabled && contract.contract_type && contract.contract_type.order >= plan.order,
                                                }"
                                            >
                                                <span>Gestión documental</span>
                                            </div>
                                            <div
                                                class="flex-grow-1 d-flex align-center headline"
                                                :class="{
                                                    selected: plan.id === service_plan,
                                                    disabled: disabled && contract.contract_type && contract.contract_type.order >= plan.order,
                                                }"
                                            >
                                                <span v-if="plan.duration.split(' ')[0] == '365'">{{ plan.price }} €/año</span>
                                                <span v-else> {{ plan.price }} €/{{ plan.duration.split(' ')[0] }} días</span>
                                            </div>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-radio-group>

                        <div>*Pago anual, impuestos no incluidos.</div>

                        <v-row>

                            <v-col cols="12" offset-md="10" md="2">

                                <slot name="quiet"></slot>

                                <v-btn
                                    :disabled="!valid || submitting"
                                    block
                                    color="secondary"
                                    @click="submit_func"
                                >
                                    {{ btn_text }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-col>
            </v-row>
        </v-container>
    </landing>
</template>

<script>
    import Landing from "@/components/layout/Landing";
    import { mapActions, mapGetters } from "vuex";
    // import { STATUS } from "../store/modules/me";
    import { mapFields } from 'vuex-map-fields';

    export default {
        name: "ContractComponent",
        components: {
            Landing,
        },
        props: {
            title: {
                type: String,
                required: false,
                default: '',
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
            btn_text: {
                type: String,
                required: false,
                default: '',
            },
            submit_func: {
                type: Function,
                required: true
            },
            submitting: {
                type: Boolean,
                required: true
            },
        },

        data() {
            return {
                valid: false,
                // submitting: false,
                // form: {
                //     service_plan: undefined,
                //     status: STATUS.DOWNLOADING_CONNECTOR,
                // },
                requiredRule: [(v) => Boolean(v) || "required"],

                contract: {},
            };
        },
        created() {
            this.service_plan = undefined;
            this.getContractTypes()
            this.refreshUserData().then(() => {
                for (let i in this.userData.contracts) {
                    if (this.userData.contracts[i]['is_vigente']) {
                        this.contract = this.userData.contracts[i];
                    }
                }
            });
        },

        methods: {
            previousStep() {
                this.$emit("previousStep");
            },
            selectPlan(id) {
                this.service_plan = id;
            },
            // async submit() {
            //     this.submitting = true;
            //     try {
            //         await this.createContract(this.form.service_plan);
            //     } catch (error) {
            //         console.error(error);
            //     } finally {
            //         this.submitting = false;
            //     }
            // },
            ...mapActions({
                refreshUserData: "me/refreshUserData",
                getContractTypes: "contracts/getContractTypes",
                createContract: "contracts/createContract",
            }),
            fetchData(){
                
            }
        },
        computed: {
            ...mapGetters({
                userData: "me/userData",
            }),
            ...mapFields('contracts', ['contract_types', 'service_plan']),
        },
    };
</script>

<style lang="scss" scoped>
    .plans div {
        cursor: pointer;
        background-color: #3cf;
        color: white;
        width: 100%;
        margin: 10px;
        padding: 2px 10px;
        font-weight: bold;
        border-radius: 5px;
        &.selected {
            background-color: yellow;
            color: #3cf;
        }
        &.disabled {
            opacity: 50%;
        }
        &:first-child {
            background-color: transparent;
        }
        span {
            margin: auto;
        }
    }
</style>
